import ErrMessage from './err-message';

export * from './err-message';
export default ErrMessage;
